import { useMemo, useContext, useState } from 'react'
import ClientContext from 'contexts/ClientContext'
import { useLocation, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import User from 'components/assets/icons/User'
import Notes from 'components/assets/icons/Notes'
import Thundercloud from 'components/assets/icons/Thundercloud'
import ChatLine from 'components/assets/icons/ChatLine'
import SignOutIcon from 'components/assets/icons/SignOutIcon'
import { getNavMenuIconColor, isMobile } from 'helpers/styles'
import Link from 'components/common/Link/Link'
import style from './NavMenu.module.scss'
import Header from 'components/Header/Header'
import PoweredBy from 'components/assets/icons/PoweredBy'

const NavMenu = ({ onNavItemClick }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const [ isHover, setIsHover ] = useState(null)
  const { color, colabelNeutralLight, colabelNeutralMid, colabelNeutralDark } = useContext(ClientContext)

  const signOut = () => {
    localStorage.removeItem('accessToken')
    navigate('sign-in')
  }

  const handleNavMenuClick = path => {
    if (isMobile()) {
      onNavItemClick(path)
    } else {
      navigate(path)
    }
  }


  const navItems = useMemo(() => {
    const getColor = (page) => {
      const defaultColor = getNavMenuIconColor(pathname, page)
      return color
        ? defaultColor === '#FF9D0E'
          ? color
          : colabelNeutralDark
        : defaultColor
    }

    return [
      // not for MVP1
      // {
      //   icon: <HomeSmile styles={{ fill: getNavMenuIconColor(pathname, '/') }} />,
      //   title: 'Accueil',
      //   path: '/',
      // },
      {
        icon: <User styles={{ fill: getColor('/contacts') }} />,
        title: t('common:menu.contactDetails'),
        path: '/contacts',
      },
      {
        icon: <Notes styles={{ fill: getColor('/contracts') }} />,
        title: t('common:menu.contract'),
        path: '/contracts',
      },
      {
        icon: <Thundercloud styles={{ fill: getColor('/claims') }} />,
        title: t('common:menu.claims'),
        path: '/claims',
      },
      {
        icon: <ChatLine styles={{ fill: getColor('/contact-us') }} />,
        title: t('common:menu.contactOwen'),
        path: '/contact-us',
      },
    ]
  }, [t, color, colabelNeutralDark, pathname])

  return (
    <div className={style['nav-menu']} style={color && {
      background: colabelNeutralLight
    }}>
      {isMobile() && <Header className={style.header} darkBg />}

      <ul className={classNames(style.items, color && style.colabel)}>
        {navItems.map((item, index) => {
          return (
            <li
              key={`nav-item-${index}`}
              className={style.item}
              onMouseEnter={() => setIsHover(index)}
              onMouseLeave={() => setIsHover(null)}
              style={ color && {
                background: isHover === index ? colabelNeutralMid : colabelNeutralLight
              }}
            >
              <Link
                className={classNames(style['item-title'], pathname.startsWith(item.path) && style['is-active'])}
                label={<>
                  {item.icon}
                  {item.title}
                </>}
                onClick={() => handleNavMenuClick(item.path)}
                darkBg
                style={color && {color: colabelNeutralDark}}
              />
            </li>
          )
        })}
      </ul>

      <div
        className={classNames(style['sign-out'], style.item)}
        onMouseEnter={() => setIsHover(4)}
        onMouseLeave={() => setIsHover(null)}
        style={ color && {
          background: isHover === 4 ? colabelNeutralMid : colabelNeutralLight
        }}
      >
        <Link
          className={style['item-title']}
          label={<>
            <SignOutIcon styles={color && {fill: colabelNeutralDark}} />
            {t('common:menu.logout')}
          </>}
          onClick={signOut}
          darkBg
          style={color && {color: colabelNeutralDark}}
        />
      </div>

      {color && <PoweredBy className={style.powered} />}
    </div>
  )
}

export default NavMenu
